"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GridHack = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(GridHack, _PureComponent);

  var _super = _createSuper(GridHack);

  function GridHack() {
    var _this;

    (0, _classCallCheck2["default"])(this, GridHack);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "grid", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_preventScrollBack", function (e) {
      var scrollLeft = _this.props.scrollLeft;

      if (scrollLeft !== undefined && scrollLeft <= 0 && e.deltaX < 0) {
        // Prevent Scroll On Scrollable Elements, avoid browser backward navigation
        // https://alvarotrigo.com/blog/prevent-scroll-on-scrollable-element-js/
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      return;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateRef", function (x) {
      if (!_this.grid && x) {
        var _this$grid, _this$grid$_scrolling;

        _this.grid = x;
        /*
         * This hack exists because we need to add wheel event listener to the div rendered by Grid
         *
         */
        // @ts-expect-error _scrollingContainer not typed in Grid

        (_this$grid = _this.grid) === null || _this$grid === void 0 ? void 0 : (_this$grid$_scrolling = _this$grid._scrollingContainer) === null || _this$grid$_scrolling === void 0 ? void 0 : _this$grid$_scrolling.addEventListener('wheel', _this._preventScrollBack, {
          passive: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(GridHack, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      /*
       * This hack exists because in react-virtualized the
       * _columnWidthGetter is only called in the constructor
       * even though it is reassigned with new props resulting in
       * a new width for cells not being calculated so we must
       * force trigger a resize.
       *
       * https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/Grid.js#L322
       *
       */
      if (!(0, _lodash["default"])(preProps.cellSizeCache, this.props.cellSizeCache)) {
        var _this$grid2;

        (_this$grid2 = this.grid) === null || _this$grid2 === void 0 ? void 0 : _this$grid2.recomputeGridSize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$grid3, _this$grid3$_scrollin;

      // @ts-expect-error _scrollingContainer not typed in Grid
      (_this$grid3 = this.grid) === null || _this$grid3 === void 0 ? void 0 : (_this$grid3$_scrollin = _this$grid3._scrollingContainer) === null || _this$grid3$_scrollin === void 0 ? void 0 : _this$grid3$_scrollin.removeEventListener('wheel', this._preventScrollBack, {
        passive: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          setGridRef = _this$props.setGridRef,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["setGridRef"]);
      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Grid, (0, _extends2["default"])({
        ref: function ref(x) {
          if (setGridRef) setGridRef(x);

          _this2._updateRef(x);
        },
        key: "grid-hack"
      }, rest));
    }
  }]);
  return GridHack;
}(_react.PureComponent);

exports["default"] = GridHack;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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